// Module
var code = "<main-section class=dark data-title=Contact> <contact-box></contact-box> </main-section>";
// Exports
export default code;